import { useTranslation } from 'react-i18next';
import type { ReportHeaderData } from './model';
import ReportHeaderLayout from '@/components/blocks/ReportHeaderLayout';

export interface ReportHeaderProps {
    reportHeaderData: ReportHeaderData;
    name: string;
    title?: string;
}

const ReportHeader = ({ reportHeaderData, name, title }: ReportHeaderProps) => {
    const { t } = useTranslation(['overallTraineeReport', 'traineeReports'], { useSuspense: false });

    return (
        <ReportHeaderLayout>
            <div className="max-w-xl">
                <h1 className="text-[32px] font-semibold text-neutral-900">
                    {title || t('header.reportTitle', { name })}
                </h1>
                <p className="mt-7.5 text-lg font-semibold text-neutral-800">{reportHeaderData.title}</p>
                <p className="mt-1 text-base text-neutral-500">{reportHeaderData.status}</p>
            </div>
        </ReportHeaderLayout>
    );
};

export default ReportHeader;
